var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"a-button",class:{
        'a-button--processing': _vm.processing || _vm.isProcessing,
        'a-button--gray': _vm.gray,
        'a-button--selected': _vm.selected
    },attrs:{"type":_vm.type,"disabled":_vm.isProcessing},on:{"click":function($event){return _vm.handleClick($event)}}},[(_vm.icon)?_c('a-icon',{staticClass:"a-button__icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default"),(_vm.processing || _vm.isProcessing)?_c('a-icon',{staticClass:"a-button__spinner",attrs:{"icon":"SpinnerSmall"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }